import { UPDATE_BRAND_FUNCTIONS_STATE, BRAND_FUNCTION_CREATED } from './actiontypes'
import { startPageLoading, stopPageLoading } from '../page_details/actions'
import { showMessage } from '../../config/utils'
import * as API from './api';

export const updateBrandFunctionsState = payload => {
  return {
    type: UPDATE_BRAND_FUNCTIONS_STATE,
    payload
  }
}

export const getAllBrandFunctions = (payload, table_props) => {
  return dispatch => {
    dispatch(updateBrandFunctionsState({ bf_loading: true }))
    API.getAllBrandFunctions(payload, (error, response) => {
      if (!error && response && response.data && response.data.brandFunctionDetail && response.data.totalCount) {
        const t_props = table_props ? table_props : {}
        const payload = {
          ...t_props,
          bf_loading: false,
          brand_functions: response.data.brandFunctionDetail,
          total_bf_count: response.data.totalCount,
        }
        dispatch(updateBrandFunctionsState(payload))
      } else
        dispatch(updateBrandFunctionsState({ bf_loading: false }))
    })
  }
}

export const createBrandFunction = (payload, callback) => {
  return dispatch => {
    dispatch(updateBrandFunctionsState({ bf_loading: true }))
    API.createBrandFunction(payload, (error, response) => {
      if (!error && response && response.data && response.data.brandFunction && response.data.totalCount) {
        dispatch({
          type: BRAND_FUNCTION_CREATED,
          payload: response.data
        })
        callback()
      } else
        dispatch(updateBrandFunctionsState({ bf_loading: false }))
    })
  }
}

export const getBrandFunction = payload => {
  return dispatch => {
    dispatch(startPageLoading("brand function fetching"))
    API.getBrandFunction(payload, (error, response) => {
      dispatch(stopPageLoading())
      if (!error && response && response.data && response.data.brandFunction)
        dispatch(updateBrandFunctionsState({ selected_bf: response.data.brandFunction }))
    })
  }
}

export const updateBrandFunction = (payload, callback) => {
  return dispatch => {
    dispatch(startPageLoading("brand function fetching"))
    API.updateBrandFunction(payload, (error, response) => {
      dispatch(stopPageLoading())
      if (!error && response && response.data && response.data.brandFunctionDetail) {
        showMessage('success', `${payload.name} updated successfully`)
        dispatch(updateBrandFunctionsState({ selected_bf: {}, file_imported: "" }))
        callback()
      }
    })
  }
}

export const getImportedFilesForBrandFunction = payload => {
  return dispatch => {
    API.getImportedFilesForBrandFunction(payload, (error, response) => {
      if (!error && response && response.data && response.data.brandFile)
        dispatch(updateBrandFunctionsState({ file_imported: response.data.brandFile }))
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/redux/brand_function_details/actions.js